<template lang="html">
    <div>
        <list-template :queryParams="searchData" actionUrl="business/findOneBuyCarShops.action"
                       ref="one-buy-car-manager">
            <template scope="scope" slot="searchButton">
                <el-col :span="4">
                    <el-input v-model="searchData.keyword"></el-input>
                </el-col>
                <el-col :span="3">
                    <el-button @click="$refs['one-buy-car-manager'].search()" style="margin-left:10px;" type="primary">
                        搜索
                    </el-button>
                </el-col>

            </template>
            <template scope="scope" slot="item">
                <el-card class="basic-margin" v-bind:key="index" v-for="(data,index) in scope.datas">

                    <!-- <img :src="baseImageUrl+data.photo" style="width:210px;height:140px;float:left;"  alt=""> -->
                    <div class="col-md-6" style="padding:0px;padding-left:20px;">
                        <p>
                            <b>{{data.shopName}}</b>

                        </p>
                        <p>门店地址：{{data.areaDetail?data.areaDetail:'无'}}</p>
                        <p>所属公司：{{data.companyName}}</p>
                        <p>代理区域：{{data.areaName}}</p>
                        <p>联系方式：{{data.linkman?data.linkman:'无'}}<span style="color:red;" v-if="data.phone">({{data.phone}})</span>
                        </p>
                        <p>创建时间：{{data.create_time |dateFormat }}</p>

                    </div>
                    <div class="col-md-3" style="padding:0px;padding-left:20px;margin-top:40px;text-align:right;">
                        <el-button @click="startSelling(data)" name="button" type="success"><i
                                class="el-icon-upload2" style="margin-right:10px;"></i>一键上架到汽车网
                        </el-button>
                    </div>

                </el-card>
            </template>

        </list-template>
        <el-form :model="businessForm" :rules="rules" addAction="business/insertBusiness.action" label-width="120px" ref="form"
                 v-form>
            <el-dialog
                    :visible.sync="dialogVisible"
                    title="一键上架到汽车网"
                    width="30%">
                <el-form-item label="定位位置" prop="longitude">
                    <search-address-input :defaultValue="businessForm.address" @onChenged="onChange"
                                          ref="business-address"></search-address-input>
                </el-form-item>
                <el-form-item>
                    <el-amap :center="businessForm.location" :zoom="18" class="amap" ref="el-amap" style="height:300px"
                             vid="amap">
                        <el-amap-marker :position="businessForm.location"></el-amap-marker>
                    </el-amap>
                </el-form-item>

                <el-form-item label="区域" prop="areaCode" v-if="areaSelectVisible">
                    <district-and-county-cascader @onAreaChanged="onAreaChanged"
                                                  placeholder="该区域在本地汽车网无法找到，请手动选择"></district-and-county-cascader>
                </el-form-item>

                <el-form-item label="展示渠道" prop="showChannels" v-belong-to-admin>
                    <channel-select :multiple="true" @change="showChannelChange" ref="showChannel"></channel-select>
                </el-form-item>

                <el-form-item label="导流渠道" prop="clueChannels" v-belong-to-admin>
                    <channel-select :multiple="true" @change="clueChannelChange" ref="clueChannel"></channel-select>
                </el-form-item>

                <el-form-item label="商家介绍">
                    <el-input type="textarea" v-model="businessForm.businessDesc"></el-input>
                </el-form-item>
                <span class="dialog-footer" slot="footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary">确 定</el-button>
        </span>
            </el-dialog>
        </el-form>
    </div>

</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import Config from '@/framework/configs/Config'
import SearchAddressInput from './children/SearchAddressInput'
import BusinessModel from '@/framework/models/businessModel'
import channelSelect from '@/components/channelSelect'
import districtAndCountyCascader from '@/components/districtAndCountyCascader'

export default {
  components: {
    ListTemplate,
    SearchAddressInput,
    channelSelect,
    districtAndCountyCascader
  },
  data: function () {
    let _this = this
    let showChannelsLocation = (rule, value, callback) => {
      if (!_this.businessForm.showChannels || !_this.businessForm.showChannels.length) {
        return callback(new Error('请输入展示渠道'))
      } else {
        return callback()
      }
    }

    return {
      areaSelectVisible: false,
      dialogVisible: false,
      businessForm: {
        id: null,
        address: null,
        businessIcon: [],
        clueChannels: [],
        showChannels: [],
        areaName: null,
        serviceType: ['新车'],
        abutmentPersonName: null,
        abutmentPhone: null,
        areaCode: null,
        businessName: null,
        longitude: null,
        latitude: null,
        businessDesc: null,
        location: [106.566129, 29.645191],
        areas: [],
        oneBuyCarShopId: null
      },
      searchData: {
        keyword: null
      },
      baseImageUrl: Config.imageUrl,
      rules: {
        longitude: [{
          required: true,
          message: '地图坐标不能为空！'
        }],
        areaCode: [{
          required: true,
          message: '区域选择不能为空！'
        }],
        showChannels: [
          {
            required: true,
            validator: showChannelsLocation,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    onAreaChanged: function (info) {
      if (info) {
        this.businessForm.areaCode = info[info.length - 1]
      }
    },
    onFilterParams: function (params) {
      params.address = params.address.replace(params.areaName + ' ', '')
    },
    onAdded: function () {
      this.dialogVisible = false
      this.$refs['one-buy-car-manager'].search()
      this.$message({
        message: '修改成功！',
        type: 'success'
      })
    },
    startSelling: function (data) {
      this.businessForm.businessName = data.shopName
      this.businessForm.abutmentPersonName = data.linkman
      this.businessForm.abutmentPhone = data.phone
      this.businessForm.address = data.areaDetail
      this.businessForm.businessDesc = ''

      if (data.type == 3) {
        this.businessForm.businessIcon = ['/ClueDistribution/applyBusinessHeader/2018-07-20/1532076832428.jpg']
      } else {
        this.businessForm.businessIcon = ['/ClueDistribution/applyBusinessHeader/2018-07-20/1532076870380.jpg']
      }

      this.businessForm.oneBuyCarShopId = data.shopId

      let userInfo = JSON.parse(localStorage.userInfo)
      this.businessForm.createPerson = userInfo.realName

      this.dialogVisible = true
    },
    clueChannelChange: function (channels) {
      if (channels && channels.length) {
        this.businessForm.clueChannels = channels
      } else {
        this.businessForm.clueChannels = []
      }
    },
    showChannelChange: function (channels) {
      if (channels && channels.length) {
        this.businessForm.showChannels = channels
      } else {
        this.businessForm.showChannels = []
      }
    },
    onChange: function (addressInfo) {
      // 查询省市区areaCode
      this.businessForm.address = addressInfo.value

      // 查询自己的区域信息
      this.selectAreaInfo(addressInfo.province, addressInfo.city, addressInfo.county)

      this.businessForm.areaName = addressInfo.province + ' ' + addressInfo.city + ' ' + addressInfo.county

      this.center = addressInfo.location.split(',')
      this.businessForm.location = addressInfo.location.split(',')

      this.businessForm.longitude = this.businessForm.location[0]
      this.businessForm.latitude = this.businessForm.location[1]
    },
    selectAreaInfo: function (province, city, county) {
      let areaName = province + ',' + city + ',' + county
      if (province.indexOf('市') == -1) {
        areaName += '|' + province + '市,' + city + ',' + county
      } else {
        areaName += '|' + province.replace('市', '') + ',' + city + ',' + county
      }

      let _this = this
      let params = {
        areaName: areaName
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          if (datas.length == 1) {
            _this.businessForm.areaCode = datas[0].pathunid
            _this.areaSelectVisible = false
          } else {
            _this.areaSelectVisible = true
          }
        }
      }

      BusinessModel.selectAreaInfo(_this, params, listener)
    }
  }
}
</script>

<style lang="css">
</style>
